module.exports = __webpack_public_path__ + "img/logoAEL70.22c944e9.png";